module.exports = __webpack_public_path__ + "why15.webp?9af9fd578123532c09da47742acd7b70";